import { useCallback, useState } from 'react';
import { ButtonsSection } from './HoverActions.style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function HoverActions({
  Buttons,
  buttonsProps = {},
  children,
  appName
}) {
  const [showActions, setShowActions] = useState(false);
  const handleMouseEnter = useCallback(() => {
    setShowActions(true);
  }, []);
  const handleMouseLeave = useCallback(() => {
    setShowActions(false);
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    "data-test-id": `${appName}-hover-actions-root`,
    children: [showActions && /*#__PURE__*/_jsx(ButtonsSection, {
      "data-test-id": `${appName}-hover-actions-buttons-section`,
      children: /*#__PURE__*/_jsx(Buttons, Object.assign({}, buttonsProps))
    }), children]
  });
}
export default HoverActions;